import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_BriefStatusExam = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_BriefStatusExam' className='file-pdf-document'>
            <div className='file-template'>
            <h3>Brief Behavioral Health Status Exam (H2010 HO)
</h3>
<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Name </span><span className='small block'>(Last, First, Middle)</span>
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Date of Service</span>
        </td>
        <td className='w-250'>
            <span className='eleHeader'>D.O.B.</span>
        </td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='text' id='txtName' name='txtName' className='add-only'/>
        </td>
        <td className='w-250'>
            <input type='date' id='txtDateService' name='txtDateService' className='add-only'/>
        </td>
        <td className='w-250'>
            <input type='date' id='txtDob' name='txtDob' className='add-only'/>
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Service Setting</span>
        </td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='checkbox' id='cbRequest1' name='cbRequest1' className='add-only' value='Home' /> Home
        </td>
        <td className='w-250'>
            <input type='checkbox' id='cbRequest2' name='cbRequest2' className='add-only' value='Office' /> Office
        </td>
        <td className='w-250'>
            <input type='checkbox' id='cbRequest3' name='cbRequest3' className='add-only' value='School' /> School
        </td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Purpost Of Exam</span>
        </td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='checkbox' id='cbClinical' name='cbClinical' className='add-only' value='Clinical' /> Brief Clinical Interview
        </td>
        <td className='w-250'>
            <input type='checkbox' id='cbClinical2' name='cbClinical2' className='add-only' value='Diagnostic' /> Brief Diagnostic Interview
        </td>
        <td className='w-250'>
            <input type='checkbox' id='cbClinical3' name='cbClinical3' className='add-only' value='Evaluative' /> Brief Evaluative Interview
        </td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='checkbox' id='cbClinical4' name='cbClinical4' className='add-only' value='Psychiatric' /> Brief Psychiatric Interview
        </td>
        <td className='w-250'>&nbsp;
        </td>
        <td className='w-250'>&nbsp;
        </td>
    </tr>
</table>
<p className='w-750'><h3>BRIEF MENTAL STATUS
</h3></p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Appearance</span>
        </td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbNeat9' name='cbNeat9' className='add-only' value='Neat'/> Neat
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbNeat8' name='cbNeat8' className='add-only' value='Dirty'/> Dirty
        </td>
        <td className='w-300'>
            <input type='checkbox' id='cbNeat7' name='cbNeat7' className='add-only' value='Appears'/> Appears Stated Age
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbNeat6' name='cbNeat6' className='add-only' value='Disheveled'/> Disheveled
        </td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbNeat5' name='cbNeat5' className='add-only' value='Appropriate'/> Appropriate
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbNeat4' name='cbNeat4' className='add-only' value='Clean'/> Clean
        </td>
        <td className='w-300'>
            <input type='checkbox' id='cbNeat3' name='cbNeat3' className='add-only' value='Older'/> Appears Older than Stated Age
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbNeat2' name='cbNeat2' className='add-only' value='Inappropriate'/> Inappropriate
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='checkbox' id='cbNeat1' name='cbNeat1' className='add-only' value='Younger'/> Appears Younger than Stated Age
        </td>
        <td className='w-150'>&nbsp;
        </td>
        <td className='w-300'>&nbsp;
        </td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Orientation</span>
        </td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbOrientation1' name='cbOrientation1' className='add-only' value='Person'/> Person
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbOrientation2' name='cbOrientation2' className='add-only' value='Object'/> Object
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbOrientation3' name='cbOrientation3' className='add-only' value='Place'/> Place
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbOrientation4' name='cbOrientation4' className='add-only' value='Time'/> Time
        </td>
        <td className='w-150'>&nbsp;
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Stated Mood</span>
        </td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbMood' name='cbMood' className='add-only' value='Dysphoric'/> Dysphoric
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbMood1' name='cbMood1' className='add-only' value='Expansive'/> Expansive
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbMood2' name='cbMood2' className='add-only' value='Good'/> Good
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbMood3' name='cbMood3' className='add-only' value='Okay'/> Okay
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbMood4' name='cbMood4' className='add-only' value='Bad'/> Bad
        </td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbMood5' name='cbMood5' className='add-only' value='Elevated'/> Elevated
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbMood6' name='cbMood6' className='add-only' value='Irritable'/> Irritable
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbMood7' name='cbMood7' className='add-only' value='Euthymic'/> Euthymic
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbMood8' name='cbMood8' className='add-only' value='Tired'/> Tired
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbMood9' name='cbMood9' className='add-only' value='Mad'/> Mad
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='checkbox' id='cbMood10' name='cbMood10' className='add-only' value='Other' /> Other
            <input type='text' id='txtOtherName' name='txtOtherName' className='add-only w-375 custom-add-only'/>
        </td>
        
    </tr>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Affect</span>
        </td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbAffect8' name='cbAffect8' className='add-only' value='Normal' /> Normal
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbAffect7' name='cbAffect7' className='add-only' value='Flat' /> Flat
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbAffect6' name='cbAffect6' className='add-only' value='Labile' /> Labile
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbAffect5' name='cbAffect5' className='add-only' value='Broad' /> Broad
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbAffect4' name='cbAffect4' className='add-only' value='Blunted' /> Blunted
        </td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbAffect3' name='cbAffect3' className='add-only' value='Restricted'/> Restricted
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbAffect2' name='cbAffect2' className='add-only' value='Appropriate'/> Appropriate
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbAffect1' name='cbAffect1' className='add-only' value='Inappropriate'/> Inappropriate
        </td>
        <td className='w-150'>&nbsp;
        </td>
        <td className='w-150'>&nbsp;
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Thought Processess</span>
        </td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbThought1' name='cbThought1' className='add-only' value='Rational'/> Rational
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbThought2' name='cbThought2' className='add-only' value='Logical'/> Logical
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbThought6' name='cbThought6' className='add-only' value='Rational'/> Tangential
        </td>
        
        <td className='w-150'>
            <input type='checkbox' id='cbThought4' name='cbThought4' className='add-only' value='Flight'/> Flight of Ideas
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbThought5' name='cbThought5' className='add-only' value='Irrational'/> Irrational
        </td>
    </tr>
    <tr>
        
        <td className='w-300'>
            <input type='checkbox' id='cbThought3' name='cbThought3' className='add-only' value='Loose'/> Loose Associations
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbThought7' name='cbThought7' className='add-only' value='Logical'/> Circumstantial
        </td>
        <td className='w-150'>&nbsp;
        </td>
        <td className='w-150'>&nbsp;
        </td>
        
    </tr>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Hallucinations</span>
        </td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbHallucinations7' name='cbHallucinations7' className='add-only' value='Audio'/> Audio
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbHallucinations6' name='cbHallucinations6' className='add-only' value='Visual'/> Visual
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbHallucinations5' name='cbHallucinations5' className='add-only' value='Olfactory'/> Olfactory
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbHallucinations4' name='cbHallucinations4' className='add-only' value='Denied'/> Denied
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbHallucinations3' name='cbHallucinations3' className='add-only' value='Gustatory'/> Gustatory
        </td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbHallucinations2' name='cbHallucinations2' className='add-only' value='Kinesthetic'/> Kinesthetic
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbHallucinations1' name='cbHallucinations1' className='add-only' value='Command'/> Command
        </td>
        <td className='w-150'>&nbsp;
        </td>
        <td className='w-150'>&nbsp;
        </td>
        <td className='w-150'>&nbsp;
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Memory</span>
        </td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbMemory1' name='cbMemory1' className='add-only' value='Immediate'/> immediate
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbMemory2' name='cbMemory2' className='add-only' value='Short'/> Short Term
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbMemory3' name='cbMemory3' className='add-only' value='Long'/> Long Term
        </td>
        <td className='w-150'>&nbsp;
        </td>
        <td className='w-150'>&nbsp;
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Concentration</span>
        </td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbConcentration1' name='cbConcentration1' className='add-only' value='Good' /> Good
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbConcentration2' name='cbConcentration2' className='add-only' value='Limited' /> Limited
        </td>
        <td className='w-150'>
            <input type='checkbox' id='cbConcentration3' name='cbConcentration3' className='add-only' value='Poor' /> Poor
        </td>
        <td className='w-150'>&nbsp;
        </td>
        <td className='w-150'>&nbsp;
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Findings</span>
    <textarea id='txtFindings' name='txtFindings' className='add-only'></textarea>
</p>
<h4>Diagnostic Formulation
</h4>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>(DSM-5):</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtDiagnostic' name='txtDiagnostic' className='add-only '/>
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>(ICD-10):</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtDiagnostic1' name='txtDiagnostic1' className='add-only'/>
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Plan</span>
    <input type='checkbox' id='cbPlan' name='cbPlan' className='add-only' value='Plan' />
    Eligible for services in accordance with FL Medicaid CBHS Handbook
</p>


                
            </div>
        </form>

    )
}











